import React from "react";
import { AlertComponent, LoginComponent, ShowContent } from "../../components";
import { useContext, useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import AuthContext from "../../context/AuthContext";
import { Box, Container, Fade } from "@mui/material";
import { getSsoErrorInfo } from "../../utils/ssoError";

export const LoginPage = () => {
  const { onLogin, isLoading, isSuccess, isError } = useContext(AuthContext);
  const location = useLocation();
  const [ssoError, setSsoError] = useState<string | null>(null);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const urlError = getSsoErrorInfo(params);
    const storedError = sessionStorage.getItem("ssoError");
    const nextError = location.state?.error || storedError || urlError?.message;

    if (!nextError) return;

    setSsoError(nextError);
    sessionStorage.removeItem("ssoError");

    const timer = window.setTimeout(() => setSsoError(null), 12000);
    return () => window.clearTimeout(timer);
  }, [location]);

  let content: JSX.Element | JSX.Element[];
  content = (
    <Box
      sx={{
        minHeight: "100vh",
        background: "linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        position: "relative",
        overflow: "hidden",
        "&::before": {
          content: '""',
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background:
            "radial-gradient(circle at 30% 50%, rgba(251, 171, 53, 0.08) 0%, transparent 50%), radial-gradient(circle at 70% 50%, rgba(90, 100, 119, 0.05) 0%, transparent 50%)",
          pointerEvents: "none",
        },
      }}
    >
      <Container maxWidth="sm">
        <Fade in timeout={1000}>
          <Box
            sx={{
              position: "relative",
              zIndex: 1,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: 2,
            }}
          >
            <LoginComponent onClickLogin={onLogin} />

            {isSuccess && <AlertComponent type="success" />}
            {isError && (
              <AlertComponent
                type="error"
                message={"Not Authorized, please contact the Administrator"}
              />
            )}
            {ssoError && <AlertComponent type="error" message={ssoError} />}
          </Box>
        </Fade>
      </Container>
    </Box>
  );

  return <ShowContent error={""} isLoading={isLoading} content={content} />;
};
